import * as  React from 'react'
import MenuItem from '../MenuItem'
import './index.scss'

const MenuList: React.SFC<any> = ({ items }) => {
  return (
    <ul className="decode-navigation">
      {
        items && items.map((item: { text: string, link: string, linkType: string, newTab: boolean }) => {
          return <MenuItem content={item.text} link={ item.link } isExternal={item.linkType === 'external' ? true : false} newTab={ item.newTab ? item.newTab : false } route={item.link} key={`${item.text}-${item.link}`} />;
        })
      }
    </ul>
  )
}

export default MenuList


// WEBPACK FOOTER //
// ./src/components/common/MenuList/index.tsx